import { Component, Injector, Input, OnInit } from '@angular/core';
import { take } from 'rxjs/operators';
import { WidgetBaseComponent } from '../../widgetBase';
import { ObjectUtil } from '../../../../../components/common/object-util/object-util';

/**
 * HardcoreTopslice Widget
 */
@Component({
  selector: 'hardcore-topslice-widget',
  templateUrl: './hardcore-topslice-widget.component.html',
  styleUrls: ['./hardcore-topslice-widget.component.scss']
})
export class HardcoreTopsliceWidgetComponent extends WidgetBaseComponent implements OnInit {

  /**
   * Widget Guid
   */
  @Input() widgetGuid: string;

  /**
   * Per area label used in widget
   */
  pa = 'pa';//used in html

  /**
  * Constructor
  */
  constructor(injector: Injector) {
    super(injector, 'hardcoreTopSlice', false);
  }

  /**
   * Initializes the component
   */
  ngOnInit() {
    // will call registerEvents and onInitialized when config (this.widgetConfig and this.page) is ready
    this.initWidgetConfig();
    this.widgetResized();
  }

  /**
   * Called by base class to inform widget that it is initialized
   * Mostly used to define where widget data should be loaded from
   */
  onInitialized(): void {
    if (!this.widgetConfig.hashtagSupported) {
      this.widgetConfig.hashtagSupported = true;
    }
    this.mockupData$ = this.widgetService.loadMockup('hardcoreTopSlice').pipe(take(1));

    this.widgetData$ = this.mockup ?
      this.mockupData$
      : this.widgetService.load('hardcoreTopSlice', this.getReport()).pipe();
  }

  /**
   * Called by base class to let widget register to various app events (like saving, loading, resizing etc)
   */
  registerEvents(): void {
    this.useDefaultServiceSaveChangesHandler("hardcoreTopSlice", this.provideSaveObject.bind(this));
  }

  /**
   * Called by base class in save process. Widget should return object to be saved
   */
  async provideSaveObject(): Promise<any> {
    const saveObject = ObjectUtil.deepCopy(this.widgetData); //Deep copy because we'd change the UI
    // percentages are in form of 0.13 for 13% => convert
    this.percentageFromUI(saveObject, "yieldEy");

    return saveObject;
  }

  /**
   * Called by base class to inform widget about save action result
   * @param _success {boolean} The result of save action
   * @param _err {any} The error object, if save action failed
   */
  saveCompleted(_success: boolean, _err: any = null): void {
    //do something if error
  }

  /**
   * Called by base class to let widget preprocess loaded data if required
   */
  preprocessLoadedData(data) {
    // percentages are in form of 0.13 for 13% => convert
    this.percentageToUI(data, "yieldEy");

    return data;
  }
}
